import React, { Component, createRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { onEvent } from 'helpers/EventHelpers';
import { SmallLoader } from 'components/Loader';
import {
  getLists,
  getListsForItemId,
  heartProduct,
  unHeartProduct
} from 'actions/hearts';
import NewCollectionModal from 'components/account/NewCollectionModal';
import css from 'styles/components/account/socialCollectionsWidget.scss';

export class SocialCollectionsWidget extends Component {
  static contextTypes = {
    testId: PropTypes.func
  };

  static defaultProps = {
    canAddNewCollection: false
  }

  constructor(props) {
    super(props);
    this.listContainer = createRef();
  }

  state = {
    showMore: false,
    showNewCollectionModal: false,
    isLoading: false
  }

  componentDidMount() {
    // if you click anywhere outside of dropdown, close it
    const itemId = this.props.getStyleId();
    onEvent(document.body, 'click', e => {
      if (!e.target.closest(`[data-collection="${itemId}"]`)) {
        this.setState({ showMore: false });
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { colorId } = this.props;

    if (prevProps.colorId !== colorId) {
      this.onGetListsForItemId();
    }
  }

  makeCustomerLists = () => {
    const { showMore, isLoading } = this.state;
    const {
      canAddNewCollection,
      hearts: {
        lists,
        itemIdLists
      }
    } = this.props;

    return (
      <div
        className={css.lists}
        tabIndex="-1"
        ref={this.listContainer}>

        { canAddNewCollection && <button className={css.addNew} aria-expanded={showMore} onClick={this.onAddNewCollection}>Add to new Collection</button> }

        { (lists && itemIdLists && !isLoading) ? lists.map(({ listId, name }) => {
          const matchingList = itemIdLists.find(itemIdList => listId === itemIdList.listId);

          return (
            <Fragment key={listId}>
              <input
                id={`${listId}`}
                onChange={this.onCollectionChange}
                defaultChecked={matchingList}
                type="checkbox" />
              <label htmlFor={`${listId}`}>{name}</label>
            </Fragment>
          );
        }) : <SmallLoader />
        }
      </div>
    );
  }

  onGetListsForItemId = () => {
    const { getStyleId, getListsForItemId } = this.props;
    const itemId = getStyleId();

    getListsForItemId({ itemId }).then(() => {
      this.setState({ isLoading: false });
      this.listContainer.current?.focus();
    });
  }

  onCollectionOpenToggle = () => {
    const { showMore } = this.state;
    const { getLists, hearts: { lists } } = this.props;

    if (!showMore) {
      if (!lists) {
        getLists().then(this.onGetListsForItemId);
      } else {
        this.onGetListsForItemId();
      }

      this.setState({ isLoading: true });
    }
    this.setState({ showMore: !showMore });
  }

  onCollectionChange = e => {
    const { heartProduct, unHeartProduct, getStyleId, shouldCollectionRefresh = true } = this.props;
    const { checked, id } = e.currentTarget;
    const styleId = getStyleId();

    this.setState({ isLoading: true });

    // `checked` comes back as the state it "will be" once its been clicked
    const heartType = checked ? heartProduct : unHeartProduct;

    heartType({ itemId: styleId, listId: id }, this.onGetListsForItemId, { shouldFetchHeartList: shouldCollectionRefresh });
  }

  onSaveNewCollection = response => {
    const { heartProduct, getStyleId, getLists } = this.props;
    const { listId } = response;
    const itemId = getStyleId();
    this.setState({ showNewCollectionModal: false, showMore: true });
    heartProduct({ itemId, listId }, () => {
      getLists().then(this.onGetListsForItemId);
    }, { shouldFetchHeartList: false });
  }

  onAddNewCollection = e => {
    e.preventDefault();
    this.setState({ showNewCollectionModal: true });
  }

  render() {
    const { showMore, showNewCollectionModal } = this.state;
    const { canAddNewCollection, getStyleId } = this.props;
    const itemId = getStyleId();

    return (
      <>
        { canAddNewCollection && <NewCollectionModal showNewCollectionModal={showNewCollectionModal} onDoneModal={this.onSaveNewCollection} /> }
        <div className={css.container} data-collection={itemId}>
          <button className={css.addToButton} onClick={this.onCollectionOpenToggle}>Add to a Collection</button>
          { showMore && this.makeCustomerLists() }
        </div>
      </>
    );
  }
}

export const mapStateToProps = state => ({
  hearts: state.hearts,
  colorId: state.product.colorId
});

export default connect(mapStateToProps, {
  getLists,
  getListsForItemId,
  heartProduct,
  unHeartProduct
})(SocialCollectionsWidget);
